import React from 'react';
import PropTypes from 'prop-types';

// education-onboarding
import {GOALS} from '../constants';
import BaseStep from 'high-school-student/account-conversion/components/base-step';
import AchievementCards from 'shared/registration/components/achievement-cards';

const propTypes = {
  goals: PropTypes.array,
  addGoal: PropTypes.func.isRequired,
  removeGoal: PropTypes.func.isRequired,
};

const Goals = ({goals, addGoal, removeGoal}) => (
  <BaseStep stepHeader="What is a goal you’d like to achieve this term?" width={780}>
    <AchievementCards
      userSelectedItems={goals}
      saveItem={addGoal}
      removeItem={removeGoal}
      items={GOALS}
      trackPrefix="education-onboarding-goal"
    />
  </BaseStep>
);

Goals.propTypes = propTypes;

export default Goals;
